import styled from 'styled-components';

import h6Styles from '../styles/h6Styles';

const Heading6 = styled.h6`
    ${h6Styles}
`;

export default Heading6;
